import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/main.scss';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import Enquiries from './components/Enquiries';
import StudentList from './components/StudentList';
import CourseList from './components/CourseList';
import FeeList from './components/FeeList';
import StaffList from './components/StaffList';
import Attendance from './components/Attendance';
import ScannerAttendance from './components/ScannerAttendance';
import ExamList from './components/ExamList';
import LMS from './components/LMS';
import InventoryList from './components/InventoryList';
import ExpenseList from './components/ExpenseList';
import ProfileSettings from './components/ProfileSettings';
import Login from './components/Login';
import Signup from './components/Signup';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import TwoFactorAuth from './components/TwoFactorAuth';
import SuperAdminDashboard from './components/SuperAdminDashboard';
import SupportTickets from './components/SupportTickets';
import SuperAdminTickets from './components/SuperAdminTickets';
import Onboarding from './components/Onboarding';
import ActivityLogs from './components/ActivityLogs';


import { SettingsProvider } from './context/SettingsContext';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  if (!token) return <Navigate to="/login" />;

  // If user is admin and school is not onboarded, force them to onboarding
  if (user.role === 'admin' && user.school && !user.school.is_onboarded) {
    return <Navigate to="/onboarding" />;
  }

  return children;
};

const AuthRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  if (token) {
    if (user.role === 'super_admin') {
      return <Navigate to="/super-admin" />;
    }
    if (user.role === 'admin' && user.school && !user.school.is_onboarded) {
      return <Navigate to="/onboarding" />;
    }
    return <Navigate to="/" />;
  }

  return children;
};

const OnboardingRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  if (!token) return <Navigate to="/login" />;

  if (user.role === 'super_admin' || (user.school && user.school.is_onboarded)) {
    return <Navigate to="/" />;
  }

  return children;
};

function App() {
  return (
    <SettingsProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<AuthRoute><Login /></AuthRoute>} />
          <Route path="/signup" element={<AuthRoute><Signup /></AuthRoute>} />
          <Route path="/forgot-password" element={<AuthRoute><ForgotPassword /></AuthRoute>} />
          <Route path="/reset-password" element={<AuthRoute><ResetPassword /></AuthRoute>} />
          <Route path="/verify-2fa" element={<AuthRoute><TwoFactorAuth /></AuthRoute>} />
          <Route path="/onboarding" element={<OnboardingRoute><Onboarding /></OnboardingRoute>} />


          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="enquiries" element={<Enquiries />} />
            <Route path="students" element={<StudentList />} />
            <Route path="courses" element={<CourseList />} />
            <Route path="fees" element={<FeeList />} />
            <Route path="staff" element={<StaffList />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="attendance/quick-scan" element={<ScannerAttendance />} />
            <Route path="exams" element={<ExamList />} />
            <Route path="lms" element={<LMS />} />
            <Route path="inventory" element={<InventoryList />} />
            <Route path="expenses" element={<ExpenseList />} />
            <Route path="profile" element={<ProfileSettings />} />
            <Route path="support" element={<SupportTickets />} />
            <Route path="activity-logs" element={<ActivityLogs />} />
            <Route path="super-admin" element={<SuperAdminDashboard />} />
            <Route path="super-admin/tickets" element={<SuperAdminTickets />} />
          </Route>
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </SettingsProvider>
  );
}
export default App;
